var cov_2o238jqjzg = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Radio/Radio.ts",
      hash = "655d834a6afe61be2fdc59ff92513575967f98a1",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Radio/Radio.ts",
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import checkItem from '../Checkbox/CheckItem';
export default checkItem('radio');